
import { Popover, PopoverMenuProps } from '@tinper/m';
import ChevronDown from '@tinper/m-icons/lib/cjs/ChevronDown';
import type {
  HyperlinksProps,
  Protocol,
} from './iHyperlinks';


type SelectProtocolProps = Pick<HyperlinksProps, 'disabled' | 'readOnly'> & {
  protocol: Protocol;
  onSelect: PopoverMenuProps['onAction'];
  classPrefix: string;
  fieldid: string;
};

function SelectProtocol({
  onSelect,
  disabled,
  protocol,
  readOnly,
  classPrefix,
  fieldid,
}: SelectProtocolProps) {
  const showText = `${protocol}//`;

  return disabled || readOnly ? (
    <span className={`${classPrefix}-link-protocol`}>{showText}</span>
  ) : (
    <Popover.Menu
      actions={[
        { key: 'https:', text: 'https://' },
        { key: 'http:', text: 'http://' },
      ]}
      onAction={onSelect}
      fieldid={fieldid}
    >
      <div
        className={`${classPrefix}-link-protocol`}
        fieldid={`${fieldid}-trigger`}
      >
        <span> {showText}</span>
        <ChevronDown />
      </div>
    </Popover.Menu>
  );
}

export default SelectProtocol;
